import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import INDUSTRIES from '../../data/industries.generated.json';

// Local-service verticals we have a ready-made solution for.
export default function IndustriesTeaser() {
  return (
    <section className="border-t border-line py-16 md:py-24">
      <div className="container-x">
        <div className="max-w-3xl">
          <h2 className="reveal display-lg">Local business? Your site is half built already.</h2>
          <p className="reveal lede mt-6" data-delay="80">
            Ten local-service verticals, each with a finished demo you can open before you spend a dollar.
          </p>
        </div>
        <ul className="mt-10 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-line bg-line md:grid-cols-3 lg:grid-cols-4">
          {INDUSTRIES.map((ind) => (
            <li key={ind.slug} className="reveal bg-ink">
              <Link to={'/industries/' + ind.slug} className="group flex h-full items-center justify-between gap-3 p-6 transition-colors hover:bg-deep">
                <span className="font-display text-xl font-medium tracking-tight md:text-2xl">{ind.name}</span>
                <ArrowUpRight className="h-5 w-5 shrink-0 text-dim transition-colors group-hover:text-sky" />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
